<template>
  <el-dialog
    :visible.sync="showEdit"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="直通车"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="station-edit"
  >
    <el-form label-position="left" ref="form" :model="form" :rules="rules">
      <el-form-item label="选拔条件" prop="condition" >
        <el-input v-model="form.condition" type="textarea"  :rows="3" placeholder="请输入选拔条件"></el-input>
      </el-form-item>
      <el-form-item label="资助计划" prop="support">
        <el-input type="textarea" v-model="form.support" :rows="3" placeholder="请输入资助计划"></el-input>
      </el-form-item>
      <el-form-item label="培养目标" prop="goal">
        <el-input type="textarea"  :rows="3" v-model="form.goal" placeholder="请输入培养目标"></el-input>
      </el-form-item>
      <el-form-item label="解约方式" prop="termination">
        <el-input type="textarea"  :rows="3" v-model="form.termination" placeholder="请输入解约方式"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5"  size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>
let defaultForm={
  condition:undefined,
  support:undefined,
  goal:undefined,
  termination:undefined,
  company_id:undefined
}
import { AddServiceWorkCompanyProgramme ,GetServiceWorkCompanyProgramme,updateServiceWorkCompany,EditServiceWorkCompanyProgramme} from "@/api/axj-service/axj-service-work"

export default {
  name: "direct-edit",
  methods:{
    initData(){
      return new Promise((resolve,reject)=>{
        GetServiceWorkCompanyProgramme({
          where:JSON.stringify({
            company_id:this.company_id
          })
        }).then(res=>{
          resolve(res)
        },error=>{
          reject(error)
        })
      })
    },
    handleSubmit: function () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.company_id=this.company_id
          if(this.isCreate){
            await this.addCompanyProgramme()
            await this.updateCompany()
          }else{
            await this.updateCompanyProgramme()
          }
          this.handleClose()
        }
      })
    },
    updateCompany(){
      return new Promise((resolve,reject)=>{
        updateServiceWorkCompany({
          have_programme:1,
          id:this.company_id
        })
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    updateCompanyProgramme(){
      return new Promise((reso,err)=>{
        EditServiceWorkCompanyProgramme(this.form).then(res=>{
          this.$message({
            type:'success',
            message:"直通车修改成功！"
          })
          reso(res)
        },error => {
          err(error)
        })
      })
    },
    addCompanyProgramme(){
     return new Promise((reso,err)=>{
       AddServiceWorkCompanyProgramme(this.form).then(res=>{
         this.$message({
           type:'success',
           message:"直通车创建成功！"
         })
         reso(res)
       },error => {
         err(error)
       })
     })
    },
    async handleOpen(){
      let res=await this.initData()


      if(res.data.lists.length==0){
        this.isCreate=true
      }else{
        let data=res.data.lists[0]

        this.form = Object.assign({},this.defaultForm, data)
        this.$delete(this.form,'created_at')
        this.$delete(this.form,'deleted_at')
        this.$delete(this.form,'updated_at')
        this.$delete(this.form,'Company')
        this.isCreate=false
      }
    },
    handleClose(){
      this.form=Object.assign({}, defaultForm)
      this.$emit("update:show",false)
    }
  },
  data(){
    return{
      isCreate:false,
      showEdit:false,
      form:Object.assign({}, defaultForm),
      rules: {
        condition: [
          { required: true, message: '请输入选拔条件', trigger: 'blur,change' }
        ],
        support: [
          { required: true, message: '请输入资助计划', trigger: 'blur,change' }
        ],
        goal: [
          { required: true, message: '请输入培养目标', trigger: 'blur,change' }
        ],
        termination: [
          { required: true, message: '请输入解约方式', trigger: 'blur,change' }
        ]
      }
    }
  },
  props:{
    show:{
      type:Boolean,
      default:false
    },
    company_id:{
      type:Number,
      default:0
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/direct-edit/index.vue